import { MaskedOptions } from 'imask'
import { REQUIRED_VALIDATION_RULE } from '@const/validation'
import MaskedInput, { MaskedInputProps } from '@organisms/MaskedInput'
import { FieldForRender, FieldParams } from '..'

type Params = {
  placeholder: string
  mask: MaskedOptions['mask']
  isLoading?: boolean
  componentProps?: MaskedInputProps
} & FieldParams

const maskedField = (params: Params): FieldForRender => {
  const {
    label,
    placeholder,
    mask,
    isRequired,
    componentProps: props,
    big = false,
    isLoading = false,
  } = params

  const componentProps: MaskedInputProps = {
    ...props,
    isLoading,
    maskOptions: {
      mask,
    },
    placeholder,
    big,
  }

  return {
    ...params,
    label: isRequired ? `${label}*` : label,
    Component: MaskedInput,
    rules: {
      ...(isRequired ? REQUIRED_VALIDATION_RULE : { required: false }),
    },
    componentProps,
  }
}

export default maskedField
